










































import { Vue, Component, Prop } from 'vue-property-decorator';
import NavBar from '../components/common/NavBar.vue';
import InputField from '../components/common/inputs/InputField.vue';
import WellItem from '../components/common/WellItem.vue';
import Button from '../components/common/inputs/Button.vue';
import { AuthModule, User } from '@/store/modules/auth';
import SnackBar from '@/components/common/SnackBar.vue';

@Component({
  components: {
    NavBar,
    InputField,
    WellItem,
    Button,
    SnackBar
  }
})
export default class ManageTechnologies extends Vue {
  showSaveSuccess = false;
  showSaveError = false;

  get user() {
    return AuthModule.user;
  }

  mounted() {
    this.load();
  }

  async load() {
    AuthModule.loadUser();
  }

  async edit() {
    try {
      const success = await AuthModule.editUser();
      this.showSaveSuccess = success;
      setTimeout(() => {
        this.$router.push('/dashboard');
      }, 3 * 1000);
    } catch (e) {
      this.showSaveError = true;
    }
  }
}
